import { useEffect, useState } from "react"
import { createTheme } from "./createTheme"

export const useGameData = gameId => {
  const [gameData, setGameData] = useState(null)
  const [gameDataPending, setGameDataPending] = useState(true)
  const [theme, setTheme] = useState(null)

  const strapiUrl =
    process.env.STRAPI_ENDPOINT || "https://dudwpkgwkyw9w.cloudfront.net"

  useEffect(() => {
    if (!gameData) {
      fetch(`${strapiUrl}/api/co-op-games/${gameId}`)
        .then(response => response.json())
        .then(result => {
          // console.log("useGameData: ", result)
          setGameData(result?.data?.attributes?.gameData)
          setTheme(createTheme(result?.data?.attributes?.gameData, strapiUrl))
        })
        .catch(error => console.log("error", error))
        .finally(() => {
          setGameDataPending(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { gameData, gameDataPending, theme }
}
